import { render, staticRenderFns } from "./CollaborationModal.vue?vue&type=template&id=5f02e962&"
import script from "./CollaborationModal.vue?vue&type=script&lang=js&"
export * from "./CollaborationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports